(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5023],{

/***/ 8158:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thank-you",
      function () {
        return __webpack_require__(8726);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9472);
/* harmony import */ var components_blocks_process__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5508);
/* harmony import */ var data_process__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9870);
/* harmony import */ var components_blocks_testimonial__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(659);
/* harmony import */ var components_blocks_services__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(587);
/* harmony import */ var components_reuseable_ContactFooterCombo__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9266);
/* harmony import */ var components_common_SEO__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2034);
/* harmony import */ var data_keywords__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4870);




// -------- custom component -------- //







var VideoDI = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 2920).then(__webpack_require__.bind(__webpack_require__, 2920));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2920)
            ];
        }
    }
});
var LocalDI = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(362), __webpack_require__.e(4890)]).then(__webpack_require__.bind(__webpack_require__, 4890));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4890)
            ];
        }
    },
    ssr: false
});
var InternationalDI = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(362), __webpack_require__.e(7858)]).then(__webpack_require__.bind(__webpack_require__, 7858));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7858)
            ];
        }
    },
    ssr: false
});
var details = {
    pageName: "SEOptimist Agency London",
    categories: "seo, web design",
    description: "Transparent, affordable and effective technical SEO services in London for professionals, agencies and enterprise.",
    parentDirectories: ""
};
var Home = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_SEO__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                title: "".concat(data_keywords__WEBPACK_IMPORTED_MODULE_10__.HomeList[0].title, " London"),
                description: details.description,
                tag: details.categories,
                urlPT: "",
                urlENPT: "",
                url: "".concat(data_keywords__WEBPACK_IMPORTED_MODULE_10__.HomeList[0].title.toLowerCase().replace(/ /g, "-")),
                image: "img/".concat(data_keywords__WEBPACK_IMPORTED_MODULE_10__.HomeList[0].title.toLowerCase().replace(/ /g, "-"), ".jpg")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                        className: "content-wrapper home",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VideoDI, {
                                    heading: "Thank you!",
                                    title1: "AI",
                                    title2: "SEO",
                                    title3: "",
                                    movie: "1.mp4",
                                    placeholder: "1-bg.jpg",
                                    button: "website-test",
                                    fontsize1: 120,
                                    fontsize2: 120,
                                    body: "",
                                    intro: " SEO will be in touch with you soon."
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                id: "ai-seo"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blocks_process__WEBPACK_IMPORTED_MODULE_4__/* .Process1 */ .G, {
                                title: "",
                                subtitle: "AI For Faster Growth",
                                body: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "lead",
                                        children: "Dominate your industry online with our AI-powered SEO automation: Unlock quick wins, boost your revenue, and secure your spot \n                at the top of Google effortlessly."
                                    }, "100"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "lead",
                                        children: 'Our in-house tools download the details of every website in your industry, analyse all their keywords, Google positions and backlinks. \n                Then we compare this data with your site. We make a list of all the "quick wins" we can add to your site to get short term success. \n                 The resulting increase in turnover will demonstrate the benefit of our service and justify sticking with as we establish you at the top of Google for the keywords of your industry.'
                                    }, "101"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "lead text-capitalize",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                className: "more hover link-purple",
                                                href: "/blog/".concat(data_keywords__WEBPACK_IMPORTED_MODULE_10__.AI[0].title.toLowerCase().replace(/ /g, "-")),
                                                title: data_keywords__WEBPACK_IMPORTED_MODULE_10__.AI[0].title
                                            }),
                                            " "
                                        ]
                                    }, "102")
                                ],
                                list: data_process__WEBPACK_IMPORTED_MODULE_5__/* .processList1 */ .vz,
                                buttonLink: "/#contact",
                                buttonTitle: "Get in touch",
                                displayButton: "d-inline",
                                src: "/img/".concat(data_keywords__WEBPACK_IMPORTED_MODULE_10__.AI[10].title.toLowerCase().replace(/ /g, "-"), "-2.png"),
                                alt: data_keywords__WEBPACK_IMPORTED_MODULE_10__.AI[0].title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                id: "localSEO",
                                className: "mt15"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LocalDI, {
                                heading: data_keywords__WEBPACK_IMPORTED_MODULE_10__.localSEOPackages[1].title,
                                initialslide: 0,
                                body: "Our local & Technical SEO, Social & PPC services target your exact demographic in the UK."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InternationalDI, {
                                heading: "".concat(data_keywords__WEBPACK_IMPORTED_MODULE_10__.HomeList[9].title, "s"),
                                body: "Our ".concat(data_keywords__WEBPACK_IMPORTED_MODULE_10__.HomeList[9].title, "s have developed SEO straegies and multilingual software for the biggest tech companies in\n                    the USA. We apply the same strategies to make your site visible in searches for European keywords.")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blocks_testimonial__WEBPACK_IMPORTED_MODULE_6__/* .Director */ .tw, {
                                title: data_keywords__WEBPACK_IMPORTED_MODULE_10__.HomeList[6].title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blocks_services__WEBPACK_IMPORTED_MODULE_7__/* .Services22 */ .m9, {
                                title: "",
                                wordCloud: data_keywords__WEBPACK_IMPORTED_MODULE_10__
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_ContactFooterCombo__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        location: "london"
                    })
                ]
            })
        ]
    });
};
//@ts-expect-error - gen
Home.bodyClass = "transparent";
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2634,1271,7857,7727,4870,4556,6435,4022,3882,659,9774,2888,179], function() { return __webpack_exec__(8158); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);